/** Decisões que travam a obra. Depois da fase `travaEm`, mudar custa quebrar. */

export interface DecisaoCatalogo {
  chave: string
  titulo: string
  /** Fase em que a escolha precisa estar feita. */
  faseId: string
  /** A partir desta fase, inverter a escolha é reforma. */
  travaEm: string
  motivo: string
  placeholder: string
}

export const DECISOES_CATALOGO: readonly DecisaoCatalogo[] = [
  {
    chave: 'sistema-construtivo',
    titulo: 'Sistema construtivo',
    faseId: 'pre-obra',
    travaEm: 'infraestrutura',
    motivo: 'Fundação e estrutura nascem desse sistema. Trocar depois é demolir.',
    placeholder: 'Ex.: alvenaria estrutural, concreto armado, steel frame',
  },
  {
    chave: 'pe-direito',
    titulo: 'Pé-direito e gabarito',
    faseId: 'pre-obra',
    travaEm: 'superestrutura',
    motivo: 'A altura da laje trava escada, esquadria e instalações.',
    placeholder: 'Ex.: 2,70 m social, 3,00 m sala',
  },
  {
    chave: 'fundacao',
    titulo: 'Tipo de fundação',
    faseId: 'infraestrutura',
    travaEm: 'superestrutura',
    motivo: 'Radier, sapata ou estaca não se troca com a casa em pé.',
    placeholder: 'Ex.: sapata corrida, radier, estaca hélice',
  },
  {
    chave: 'impermeabilizacao-baldrame',
    titulo: 'Impermeabilização de baldrame',
    faseId: 'infraestrutura',
    travaEm: 'vedacao',
    motivo: 'Depois de enterrar, infiltração vira reforma cega.',
    placeholder: 'Ex.: manta asfáltica, cristalizante',
  },
  {
    chave: 'vao-esquadrias',
    titulo: 'Vãos de portas e janelas',
    faseId: 'vedacao',
    travaEm: 'acabamento-bruto',
    motivo: 'Vão errado obriga a quebrar alvenaria ou comprar esquadria especial.',
    placeholder: 'Ex.: janela da sala 1,50 x 1,20',
  },
  {
    chave: 'reservas-eletrica',
    titulo: 'Reservas elétricas e caixas',
    faseId: 'vedacao',
    travaEm: 'instalacoes',
    motivo: 'Fechou a parede, puxar ponto novo é quebra.',
    placeholder: 'Ex.: 4 pontos na sala, quadro no hall',
  },
  {
    chave: 'prumadas-hidro',
    titulo: 'Prumadas hidráulicas',
    faseId: 'instalacoes',
    travaEm: 'acabamento-bruto',
    motivo: 'Tubulação embutida some atrás do reboco.',
    placeholder: 'Ex.: PPR 25 mm, shafts definidos',
  },
  {
    chave: 'teste-pressao',
    titulo: 'Teste de pressão hidráulica',
    faseId: 'instalacoes',
    travaEm: 'acabamento-bruto',
    motivo: 'Vazamento depois do reboco molha piso e vizinho.',
    placeholder: 'Ex.: 24h a 1,5x a pressão de trabalho, sem perda',
  },
  {
    chave: 'impermeabilizacao-laje',
    titulo: 'Impermeabilização de laje',
    faseId: 'cobertura',
    travaEm: 'acabamento-fino',
    motivo: 'Telhou por cima de laje sem manta: infiltração é certa.',
    placeholder: 'Ex.: manta asfáltica 3 mm, duas demãos',
  },
  {
    chave: 'cota-piso',
    titulo: 'Cota e tipo de piso',
    faseId: 'acabamento-bruto',
    travaEm: 'acabamento-fino',
    motivo: 'Contramarco e porta dependem da cota final do piso.',
    placeholder: 'Ex.: porcelanato 60x60, 1 cm de rejunte',
  },
]
